// extracted by mini-css-extract-plugin
module.exports = {"image":"EdgeImage_image__iH4_q","loadError":"EdgeImage_loadError__2xPd8","fadeIn":"EdgeImage_fadeIn__3cojs"};